import React, { useEffect, useMemo, useRef, useState } from "react";

export default function CategoryTreeMenu({
  tree,
  hoveredCategoryId,
  setHoveredCategoryId,
  isMenuOpen,
  setIsMenuOpen,
}) {
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const [isMobile, setIsMobile] = useState(false);

  const hoveredCategory = tree.find((c) => c.id === hoveredCategoryId);

  // تشخیص موبایل
  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 767px)");

    const update = () => setIsMobile(mediaQuery.matches);
    update();

    mediaQuery.addEventListener?.("change", update);
    return () => mediaQuery.removeEventListener?.("change", update);
  }, []);

  // بستن منو با کلیک خارج از منو
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(e.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    const handleEsc = (e) => {
      if (e.key === "Escape") setIsMenuOpen(false);
    };

    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEsc);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [isMenuOpen, setIsMenuOpen]);

  // بستن اسکرول صفحه در موبایل هنگام باز بودن منو
  useEffect(() => {
    if (isMenuOpen && isMobile) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = originalOverflow;
      };
    }
  }, [isMenuOpen, isMobile]);

  // محاسبه تعداد ستون‌ها بر اساس تعداد زیر دسته‌ها
  const getGridCols = (childrenCount) => {
    if (childrenCount <= 4) return 1;
    if (childrenCount <= 8) return 2;
    if (childrenCount <= 12) return 3;
    return 4;
  };

  const gridCols = hoveredCategory
    ? getGridCols(hoveredCategory.children?.length || 0)
    : 1;

  const handleRootCategoryHover = (categoryId) => {
    setHoveredCategoryId(categoryId);
  };

  return (
    <div className="bg-gray-50">
      {/* دکمه باز کردن منوی دسته‌بندی */}
      <div className="relative inline-block" ref={buttonRef}>
  <button
    type="button"
    className="hidden md:flex items-center justify-center gap-2 rounded-lg bg-[#1E3A5F] px-4 py-2.5 font-medium text-[#FFC107] shadow-sm transition-colors duration-200 hover:bg-[#2B5388] hover:text-[#D19D00] focus:outline-none"
          onMouseEnter={() => !isMobile && setIsMenuOpen(true)}
          onClick={() => setIsMenuOpen((prev) => !prev)}
          aria-expanded={isMenuOpen}
          aria-haspopup="true"
        >
          <svg
            className="h-5 w-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>

          <span className="whitespace-nowrap text-sm sm:text-base">
            دسته‌بندی کالا
          </span>

          <svg
            className={`h-4 w-4 transition-transform ${
              isMenuOpen ? "rotate-180" : ""
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>
      </div>

      {/* دسکتاپ */}
      {!isMobile && isMenuOpen && (
        <div
          ref={menuRef}
          className="absolute right-0 top-full z-50 mt-[-1px] flex max-h-[calc(100vh-160px)] overflow-y-auto rounded-b-2xl rounded-tr-2xl border border-gray-200 border-t-0 bg-white shadow-sm"
          onMouseLeave={() => {
            const timer = setTimeout(() => setIsMenuOpen(false), 300);
            return () => clearTimeout(timer);
          }}
        >
          {/* سایدبار دسته‌های ریشه */}
          <aside className="flex w-64 flex-col border-l border-gray-200 bg-white">
            <div className="flex-shrink-0 border-b border-gray-100 bg-gray-50 p-4">
              <h2 className="text-base font-bold text-gray-800">
                دسته‌بندی کالاهای ساختمانی
              </h2>
            </div>

            <nav
              className="flex-1 overflow-y-auto py-2"
              style={{ maxHeight: "calc(100vh - 160px)" }}
            >
              <ul>
                {tree.map((category) => (
                  <li
                    key={category.id}
                    onMouseEnter={() => handleRootCategoryHover(category.id)}
                    className="cursor-pointer"
                  >
                    <div
                      className={`group flex items-center justify-between px-4 py-3 transition-colors duration-200 ${
                        hoveredCategoryId === category.id
                          ? "border-r-2 border-[#00AFA9] bg-gray-50 text-[#00AFA9]"
                          : "hover:bg-gray-50"
                      }`}
                    >
                      <a
                        href={`/shopping/product-list/?category_slug=${category.slug}`}
                        className={`truncate text-sm font-medium transition-colors duration-200 ${
                          hoveredCategoryId === category.id
                            ? "text-[#00AFA9]"
                            : "text-gray-700 group-hover:text-[#00AFA9]"
                        }`}
                        title={category.name}
                      >
                        {category.name}
                      </a>

                      {category.children?.length > 0 && (
                        <svg
                          className={`h-4 w-4 flex-shrink-0 ${
                            hoveredCategoryId === category.id
                              ? "text-[#00AFA9]"
                              : "text-gray-400 group-hover:text-[#00AFA9]"
                          }`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          aria-hidden="true"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 5l7 7-7 7"
                          />
                        </svg>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </nav>
          </aside>

          {/* پنجره زیردسته‌ها */}
          {hoveredCategory && (
            <div className="flex w-[500px] flex-col border-r border-gray-200 bg-white">
              <div className="flex-shrink-0 border-b border-gray-100 bg-gray-50 px-4 py-3">
                <h3 className="text-lg font-bold text-gray-800">
                  {hoveredCategory.name}
                </h3>

                <a
                  href={`/shopping/product-list/?category_slug=${hoveredCategory.slug}`}
                  className="mt-2 inline-flex w-full items-center justify-center rounded-lg bg-gray-50 px-3 py-2 text-sm font-medium text-[#00AFA9] transition-colors duration-200 hover:bg-gray-100 hover:text-[#00938E]"
                >
                  مشاهده صفحه دسته {hoveredCategory.name}
                </a>
              </div>

              <div
                className="flex-1 overflow-y-auto p-4"
                style={{ maxHeight: "calc(100vh - 200px)" }}
              >
                <div
                  className="grid gap-4"
                  style={{
                    gridTemplateColumns: `repeat(${gridCols}, minmax(160px, 1fr))`,
                  }}
                >
                  {hoveredCategory.children?.map((child) => (
                    <div key={child.id} className="space-y-2">
                      {/* سطح دوم */}
                      <a
                        href={`/shopping/product-list/?category_slug=${child.slug}`}
                        className="block truncate border-b border-gray-100 pb-2 text-sm font-semibold text-gray-800 transition-colors duration-200 hover:text-[#00AFA9]"
                        title={child.name}
                      >
                        {child.name}
                      </a>

                      {/* سطح سوم */}
                      {child.children?.length > 0 && (
                        <ul className="space-y-1 pr-2">
                          {child.children.map((sub) => (
                            <li key={sub.id}>
                              <a
                                href={`/shopping/product-list/?category_slug=${sub.slug}`}
                                className="block truncate rounded-lg px-2 py-1 text-xs text-gray-600 transition-colors duration-200 hover:bg-gray-50 hover:text-[#00AFA9]"
                                title={sub.name}
                              >
                                {sub.name}
                              </a>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* موبایل */}
      {isMobile && isMenuOpen && (
        <div className="fixed inset-0 z-50">
          {/* overlay */}
          <button
            type="button"
            aria-label="بستن منو"
            className="absolute inset-0 cursor-default bg-black/40"
            onClick={() => setIsMenuOpen(false)}
          />

          {/* drawer */}
          <div
            ref={menuRef}
            className="absolute inset-x-0 bottom-0 top-0 flex flex-col bg-white shadow-sm"
          >
            {/* هدر موبایل */}
            <div className="flex items-center justify-between border-b border-gray-200 bg-white px-4 py-3">
              <div>
                <h2 className="text-base font-bold text-gray-800">
                  دسته‌بندی کالاهای ساختمانی
                </h2>
                <p className="mt-1 text-xs text-gray-500">
                  برای مشاهده دسته‌ها روی هر بخش لمس کنید
                </p>
              </div>

              <button
                type="button"
                onClick={() => setIsMenuOpen(false)}
                className="flex h-10 w-10 items-center justify-center rounded-lg border border-gray-200 text-gray-600 transition-colors duration-200 hover:bg-gray-50"
                aria-label="بستن"
              >
                <svg
                  className="h-5 w-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* محتوای موبایل: دو پنل */}
            <div className="flex flex-1 overflow-hidden">
              {/* پنل اصلی دسته‌های ریشه - عرض کم */}
              <aside className="w-[34%] min-w-[110px] max-w-[150px] border-l border-gray-200 bg-gray-50">
                <div className="h-full overflow-y-auto py-2">
                  {tree.map((category) => (
                    <button
                      key={category.id}
                      type="button"
                      onClick={() => handleRootCategoryHover(category.id)}
                      className={`flex w-full items-center justify-between gap-2 border-r-2 px-3 py-3 text-right transition-colors duration-200 ${
                        hoveredCategoryId === category.id
                          ? "border-[#00AFA9] bg-white text-[#00AFA9]"
                          : "border-transparent text-gray-700 hover:bg-white"
                      }`}
                    >
                      <span className="truncate text-xs font-medium leading-5">
                        {category.name}
                      </span>

                      {category.children?.length > 0 && (
                        <svg
                          className={`h-3.5 w-3.5 flex-shrink-0 ${
                            hoveredCategoryId === category.id
                              ? "text-[#00AFA9]"
                              : "text-gray-400"
                          }`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          aria-hidden="true"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 5l7 7-7 7"
                          />
                        </svg>
                      )}
                    </button>
                  ))}
                </div>
              </aside>

              {/* پنل زیردسته‌ها */}
              <section className="flex-1 bg-white">
                {hoveredCategory ? (
                  <div className="flex h-full flex-col">
                    <div className="border-b border-gray-100 px-4 py-3">
                      <a
                        href={`/shopping/product-list/?category_slug=${hoveredCategory.slug}`}
                        className="block text-sm font-bold text-gray-800 transition-colors duration-200 hover:text-[#00AFA9]"
                      >
                        {hoveredCategory.name}
                      </a>

                      <a
                        href={`/shopping/product-list/?category_slug=${hoveredCategory.slug}`}
                        className="mt-2 inline-flex rounded-lg bg-gray-50 px-3 py-2 text-xs font-medium text-[#00AFA9] transition-colors duration-200 hover:bg-gray-100"
                      >
                        مشاهده صفحه دسته
                      </a>
                    </div>

                    <div className="flex-1 overflow-y-auto p-4">
                      <div className="space-y-5">
                        {hoveredCategory.children?.map((child) => (
                          <div key={child.id} className="space-y-2">
                            {/* سطح دوم */}
                            <a
                              href={`/shopping/product-list/?category_slug=${child.slug}`}
                              className="block truncate text-sm font-semibold text-gray-800 transition-colors duration-200 hover:text-[#00AFA9]"
                              title={child.name}
                            >
                              {child.name}
                            </a>

                            {/* سطح سوم */}
                            {child.children?.length > 0 && (
                              <ul className="space-y-1 pr-2">
                                {child.children.map((sub) => (
                                  <li key={sub.id}>
                                    <a
                                      href={`/shopping/product-list/?category_slug=${sub.slug}`}
                                      className="block truncate rounded-lg px-2 py-2 text-xs text-gray-600 transition-colors duration-200 hover:bg-gray-50 hover:text-[#00AFA9]"
                                      title={sub.name}
                                    >
                                      {sub.name}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="flex h-full items-center justify-center p-6 text-center">
                    <p className="text-sm text-gray-500">
                      یک دسته ریشه را انتخاب کنید
                    </p>
                  </div>
                )}
              </section>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
